
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/introduce",
      function () {
        return require("private-next-pages/introduce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/introduce"])
      });
    }
  